import * as React from "react";
const SvgSendTimeExtension = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 4h-6a2.5 2.5 0 0 0-5 0H3.01v5.8C5.7 9.8 6 11.96 6 12.5s-.29 2.7-3 2.7V21h5.8c0-2.16 1.37-2.78 2.2-2.94v-9.3l9 4.5V4z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 12v4l4 1-4 1v4l10-5z",
  fill: "currentColor"
}));
export default SvgSendTimeExtension;